export enum TabGroupLayoutEnum {
  default = 'default',
  filled = 'filled',
  buttons = 'buttons'
}
